import {CssBaseline, Grid} from '@mui/material';
import AppBar from "../components/AppBar";

const AppLayout = ({children}) => {
    return (
        <Grid style={{padding: 0}}>
            <AppBar/>
            <CssBaseline/>
            {children}
        </Grid>
    )
}
export default AppLayout;
